import classnames from 'classnames';

import styles from './SelectionIconButton.module.scss';
import { Props } from './SelectionIconButton.types';

export const SelectionIconButton = ({
  icon,
  label,
  selected,
  onClick,
  className,
  labelClassName,
  disabled = false,
}: Props) => (
  <div
    className={classnames(
      styles.container,
      { [styles.selected]: selected, [styles.disabled]: disabled },
      className
    )}
    onClick={disabled ? undefined : onClick}
  >
    <div className={styles.icon}>{icon}</div>
    <div className={classnames(styles.label, labelClassName)}>{label}</div>
  </div>
);
